// extracted by mini-css-extract-plugin
export default {"picker":"EmojiPicker_picker__ZyRcL","grid":"EmojiPicker_grid__kOkDE","emojiBtn":"EmojiPicker_emojiBtn__yerw3"};